$(document).ready(function () {
    let getIdOrderFromSession;
    let getIdMenuItemRateFromSession;
    let infomationGetFromSession;
    getIdOrderFromSession            =   sessionStorage.getItem("idOrderRate");;
    getIdMenuItemRateFromSession     =   sessionStorage.getItem("idMenuItemRate")
    // infomationGetFromSession         =   sessionStorage.getItem(`${getIdOrderFromSession}_${getIdMenuItemRateFromSession}`);
    function reload () {
          getIdOrderFromSession          =  sessionStorage.getItem("idOrderRate");
          getIdMenuItemRateFromSession   =  sessionStorage.getItem("idMenuItemRate");
          // infomationGetFromSession       =  sessionStorage.getItem(`${getIdOrderFromSession}_${getIdMenuItemRateFromSession}`);
    }

    function renderTextRate(value) {
      var label = '';
      var _color = '';
      var value = parseInt(value);
        switch (value) {
            case 1:
              label = "<label class='star-rating-desc'><b><i>So bad I couldn't eat it!</i></b></label>";
              _color = 'rgb(205, 92, 92)';
              break;
            case 2:
              label = "<label class='star-rating-desc'><b><i>Not very good, but I ate it!</i></b></label>";
              _color = 'rgb(238, 173, 14)'
              break;
            case 3:
              label = "<label class='star-rating-desc'><b><i>Worth eating if I'm already at this restaurant!</i></b></label>";
              _color = 'rgb(0, 100, 0)'
              break;
            case 4:
              label = "<label class='star-rating-desc'><b><i>Worth a trip to this restaurant!</i></b></label>";
              _color = 'rgb(0, 139, 69)'
              break;
            case 5:
              label = "<label class='star-rating-desc'><b><i>One of the best I've had!</i></b></label>";
              _color = 'rgb(50, 205, 50)'
              break;
           }
          $('body').find('.rating-description').html(label);
            $(".star-rating-desc").css({
              "background-color": _color,
              "color":"white"
          });
          setTimeout(function(){
              $(".star-rating-desc").css("background-color",'#e5eaed')
              $(".star-rating-desc").css("color",_color);
          }, 1000);
    }

    function rateItemFromSession(idOrder , idMenu) {
          infomationGetFromSession       =  sessionStorage.getItem(`${idOrder}_${idMenu}`);
          infomationGetFromSession =  jQuery.parseJSON(infomationGetFromSession);
          if (!infomationGetFromSession) return
          let price = infomationGetFromSession.price ? (infomationGetFromSession.price).replace('$','') : '';

          const $reviewContainer = $(`#reviewContainer${ idOrder ? `-${idOrder}` : '' } .id-${ idOrder ? idOrder : '' }-${ idMenu  ? idMenu : '' }`);
          let valueForPrice = infomationGetFromSession.valueForPrice ? parseInt(infomationGetFromSession.valueForPrice) : 50;
          $(`.id-${idOrder}-${idMenu} #submitItem .price-slider .slider-track .slider-selection`).css("width",`${valueForPrice}%`);
          $(`.id-${idOrder}-${idMenu} #submitItem .price-slider .slider-track .slider-track-high`).css("width", `${100 - valueForPrice}%`);
          $(`.id-${idOrder}-${idMenu} #submitItem .price-slider .slider-track .slider-handle`).css("left",`${valueForPrice}%`);
          $(`.id-${idOrder}-${idMenu} #submitItem .price-slider .flat-slider`).val(valueForPrice);
          $(`.id-${idOrder}-${idMenu} #submitItem .user-value-price`).val(price);

          const $pricetip = $(`.id-${idOrder}-${idMenu} #submitItem .price-slider .min-slider-handle`);
          $pricetip.css('position', 'relative');
          $pricetip.html(`<span class="slider-price" style=" position: absolute; top: -20px; font-size: 10px; width: 50px; text-align: center; left: -15px; font-weight: bold; ">$${price}</span>`);

          let selectedRate = infomationGetFromSession.selectedRate;
          if(selectedRate == '') selectedRate = 'Can Request'
          else{
            $(`.id-${idOrder}-${idMenu} .menuItemId-${idMenu} .setAllPref`).val(selectedRate[0]);
            $(`.id-${idOrder}-${idMenu} .menuItemId-${idMenu} select[name="dietaryPreferences.High-Protein"]`).val(selectedRate[1]);
            $(`.id-${idOrder}-${idMenu} .menuItemId-${idMenu} select[name="dietaryPreferences.Hormone-Free"]`).val(selectedRate[2]);
            $(`.id-${idOrder}-${idMenu} .menuItemId-${idMenu} select[name="dietaryPreferences.Kosher - Only cold food"]`).val(selectedRate[3]);
            $(`.id-${idOrder}-${idMenu} .menuItemId-${idMenu} select[name="dietaryPreferences.Less Sugar"]`).val(selectedRate[4]);
          }

          /*textReview*/
          $(`.id-${idOrder}-${idMenu} #submitItem .text-review`).val(infomationGetFromSession.textReview);

          /*starRating*/
          $('body').find(`.id-${idOrder}-${idMenu} #submitItem .starRating`).val(infomationGetFromSession.starRating);
          if (infomationGetFromSession) {
                  $reviewContainer.find('.shir-star-rating').parent().find('.raterater-input').remove()
                 
          }

          renderTextRate(infomationGetFromSession.starRating);
          let sweet = parseInt(infomationGetFromSession.sweet);
          $(`.expert-form-${idMenu} #sweet-rating .slider-track .slider-selection`).css("width",`${sweet}%`);
          $(`.expert-form-${idMenu} #sweet-rating .slider-track .min-slider-handle`).css("left",`${sweet}%`);
          $(`.expert-form-${idMenu} #sweet-rating .slider-track .slider-track-high`).css("width",`${100 -sweet}%`);
          $(`.expert-form-${idMenu} #sweet-rating .tooltip-main `).css("left",`${sweet}%`);
          $(`.expert-form-${idMenu} #sweet-rating input[name='expertReview.sweet']`).val(sweet);
          if (sweet > 0) {
            $(`.expert-form-${idMenu} #sweet-rating .sweetNA`).prop('checked', false);
          }else{
            $(`.expert-form-${idMenu} #sweet-rating .sweetNA`).prop('checked', true);

          }

          let salty = parseInt(infomationGetFromSession.salty);
          $(`.expert-form-${idMenu} #salty-rating .slider-track .slider-selection`).css("width",`${salty}%`);
          $(`.expert-form-${idMenu} #salty-rating .slider-track .min-slider-handle`).css("left",`${salty}%`);
          $(`.expert-form-${idMenu} #salty-rating .slider-track .slider-track-high`).css("width",`${100 -salty}%`);
          $(`.expert-form-${idMenu} #salty-rating .tooltip-main `).css("left",`${salty}%`);
          $(`.expert-form-${idMenu} #salty-rating input[name='expertReview.salty']`).val(salty);
          if ( salty > 0 ) {
            $(`.expert-form-${idMenu} #salty-rating .saltyNA`).prop('checked', false);
          }else{
            $(`.expert-form-${idMenu} #salty-rating .saltyNA`).prop('checked', true);
          }

          let savory = parseInt(infomationGetFromSession.savory);
          $(`.expert-form-${idMenu} #savory-rating .slider-track .slider-selection`).css("width",`${savory}%`);
          $(`.expert-form-${idMenu} #savory-rating .slider-track .min-slider-handle`).css("left",`${savory}%`);
          $(`.expert-form-${idMenu} #savory-rating .slider-track .slider-track-high`).css("width",`${100 -savory}%`);
          $(`.expert-form-${idMenu} #savory-rating .tooltip-main `).css("left",`${savory}%`);
          $(`.expert-form-${idMenu} #savory-rating input[name='expertReview.savory']`).val(savory);
          if ( savory > 0 ) {
            $(`.expert-form-${idMenu} #savory-rating .savoryNA`).prop('checked', false);
          }else{
            $(`.expert-form-${idMenu} #savory-rating .savoryNA`).prop('checked', true);
          }

          let bitter = parseInt(infomationGetFromSession.bitter);
          $(`.expert-form-${idMenu} #bitter-rating .slider-track .slider-selection`).css("width",`${bitter}%`);
          $(`.expert-form-${idMenu} #bitter-rating .slider-track .min-slider-handle`).css("left",`${bitter}%`);
          $(`.expert-form-${idMenu} #bitter-rating .slider-track .slider-track-high`).css("width",`${100 -bitter}%`);
          $(`.expert-form-${idMenu} #bitter-rating .tooltip-main `).css("left",`${bitter}%`);
          $(`.expert-form-${idMenu} #bitter-rating input[name='expertReview.bitter']`).val(bitter);
          if ( bitter > 0 ) {
            $(`.expert-form-${idMenu} #bitter-rating .bitterNA`).prop('checked', false);
          }else{
            $(`.expert-form-${idMenu} #bitter-rating .bitterNA`).prop('checked', true);
          }

          let sour = parseInt(infomationGetFromSession.sour);
          $(`.expert-form-${idMenu} #sour-rating .slider-track .slider-selection`).css("width",`${sour}%`);
          $(`.expert-form-${idMenu} #sour-rating .slider-track .min-slider-handle`).css("left",`${sour}%`);
          $(`.expert-form-${idMenu} #sour-rating .slider-track .slider-track-high`).css("width",`${100 -sour}%`);
          $(`.expert-form-${idMenu} #sour-rating .tooltip-main `).css("left",`${sour}%`);
          $(`.expert-form-${idMenu} #sour-rating input[name='expertReview.sour']`).val(sour);
          if ( sour > 0 ) {
            $(`.expert-form-${idMenu} #sour-rating .sourNA`).prop('checked', false);
          }else{
            $(`.expert-form-${idMenu} #sour-rating .sourNA`).prop('checked', true);
          }

          let spicy = parseInt(infomationGetFromSession.spicy);
          $(`.expert-form-${idMenu} #spicy-rating .slider-track .slider-selection`).css("width",`${spicy}%`);
          $(`.expert-form-${idMenu} #spicy-rating .slider-track .min-slider-handle`).css("left",`${spicy}%`);
          $(`.expert-form-${idMenu} #spicy-rating .slider-track .slider-track-high`).css("width",`${100 -spicy}%`);
          $(`.expert-form-${idMenu} #spicy-rating .tooltip-main `).css("left",`${spicy}%`);
          $(`.expert-form-${idMenu} #spicy-rating input[name='expertReview.spicy']`).val(spicy);
          if ( spicy > 0 ) {
            $(`.expert-form-${idMenu} #spicy-rating .spicyNA`).prop('checked', false);
          }else{
            $(`.expert-form-${idMenu} #spicy-rating .spicyNA`).prop('checked', true);
          }

          let presentation = parseInt(infomationGetFromSession.presentation);
          $(`.expert-form-${idMenu} #presentation-rating .slider-track .slider-selection`).css("width",`${presentation}%`);
          $(`.expert-form-${idMenu} #presentation-rating .slider-track .min-slider-handle`).css("left",`${presentation}%`);
          $(`.expert-form-${idMenu} #presentation-rating .slider-track .slider-track-high`).css("width",`${100 -presentation}%`);
          $(`.expert-form-${idMenu} #presentation-rating .tooltip-main `).css("left",`${presentation}%`);
          $(`.expert-form-${idMenu} #presentation-rating input[name='expertReview.presentation']`).val(presentation);
           if ( presentation > 0 ) {
              $(`.expert-form-${idMenu} #presentation-rating .presentationNA`).prop('checked', false);
          }else{
              $(`.expert-form-${idMenu} #presentation-rating .presentationNA`).prop('checked', true);
          }

          let healthy = parseInt(infomationGetFromSession.healthy);
          $(`.expert-form-${idMenu} #healthy-rating .slider-track .slider-selection`).css("width",`${healthy}%`);
          $(`.expert-form-${idMenu} #healthy-rating .slider-track .min-slider-handle`).css("left",`${healthy}%`);
          $(`.expert-form-${idMenu} #healthy-rating .slider-track .slider-track-high`).css("width",`${100 -healthy}%`);
          $(`.expert-form-${idMenu} #healthy-rating .tooltip-main `).css("left",`${healthy}%`);
          $(`.expert-form-${idMenu} #healthy-rating input[name='expertReview.healthy']`).val(healthy);
          if ( healthy > 0 ) {
            $(`.expert-form-${idMenu} #healthy-rating .healthyNA`).prop('checked', false);
          }else{
            $(`.expert-form-${idMenu} #healthy-rating .healthyNA`).prop('checked', true);
          }

          let quantity = parseInt(infomationGetFromSession.quantity);
          $(`.expert-form-${idMenu} #quantity-rating .slider-track .slider-selection`).css("width",`${quantity}%`);
          $(`.expert-form-${idMenu} #quantity-rating .slider-track .min-slider-handle`).css("left",`${quantity}%`);
          $(`.expert-form-${idMenu} #quantity-rating .slider-track .slider-track-high`).css("width",`${100 -quantity}%`);
          $(`.expert-form-${idMenu} #quantity-rating .tooltip-main `).css("left",`${quantity}%`);
          $(`.expert-form-${idMenu} #quantity-rating input[name='expertReview.quantity']`).val(quantity);
          if ( quantity > 0 ) {
             $(`.expert-form-${idMenu} #quantity-rating .quantityNA`).prop('checked', false);
          }else{
             $(`.expert-form-${idMenu} #quantity-rating .quantityNA`).prop('checked', true);
          }
    }






const reviewPageInit = function(orderId = false){
console.log("in reviewPageInit...", new Date());
  if ( orderId == getIdOrderFromSession ) {
      reload();
      getIdMenuItemRateFromSession.split(",").forEach(obj=>{
           rateItemFromSession(getIdOrderFromSession , obj);
      });
   }
  const $reviewContainer = $(`#reviewContainer${ orderId ? `-${orderId}` : '' }`);
  const $reviewContainerVal = $(`#reviewContainer${ orderId ? `-${orderId}` : '' }`).val();
  const venueId = $reviewContainer.data('venue-id');
  const venueName = $reviewContainer.data('venue-name');
  const isOrderRating = $reviewContainer.data('order-rating');
  const orderType = $reviewContainer.data('order-type');
  const selectedItems = $reviewContainer.data('selected-items');

  // const orderId = parseInt($reviewContainer.data('order-id'));
  const GET_RATING_TEMPLATE = $reviewContainer.data('get-rating-template');
  let formsLeftUnsaved = 0;
  var RESTAURANT_MOD = undefined;
  if (restaurantModule && !RESTAURANT_MOD){
    RESTAURANT_MOD = new restaurantModule();
    RESTAURANT_MOD.init();
  }
  const COMPLETE_BY_RATING_ORDER_TYPES = ['pickup', 'delivery', 'only_rate'];
  const $RESIZEIMAGEMODAL = $('#resizeImageModal');

  // Update social media sharing button
  //&&&&&&&&&&
   const updateSocialSharingBtn = ($target) => {
     const $imageContainer   = $target.find(".img-placeholder")
     let ratingValue         = $target.find(".starRating").val();
     let imageLink           = $imageContainer.attr('src');
     const $shareContainer   = $target.find(".social-share-container");
     const $facebookShareBtn = $shareContainer.find(".facebook-share-button");
     const $twitterShareBtn  = $shareContainer.find(".twitter-share-button");

     let share_href = $shareContainer.data('share-link');
     if (!$imageContainer.hasClass('no-image')) share_href += `&displayImg=${encodeURIComponent(imageLink)}`;
     if (ratingValue >=0) share_href += `&rating=${ratingValue}`;
     $facebookShareBtn.data('href', share_href);
     $twitterShareBtn.data('href', share_href);
   };

 
  // Check if star rating initialized with infomationGetFromSession
  $reviewContainer.find('.shir-star-rating').each(function() {
    $(this).parent().find('.raterater-input').remove()
    $(this).raterater({
      mode: 'input',
      allowChange: true,
      spaceWidth: 6,
      starWidth: 42
    })
  })
  if(check_iOSapp() || check_androidApp()) {
    $reviewContainer.on('blur', '.starRating', function(){
     
      $(this).parent().find('.raterater-input').remove();
      $(this).raterater({
        mode: 'input',
        allowChange: true,
        spaceWidth: 6,
        starWidth: 42
      });
    })
  }else{
    $reviewContainer.on('change', '.starRating', function(){
      
      $(this).parent().find('.raterater-input').remove();
      $(this).raterater({
        mode: 'input',
        allowChange: true,
        spaceWidth: 6,
        starWidth: 42
      });
    })
  }
    $('body').find(`.detailFood`).click(function(e) {
        let orderId     =  $('body').find('#orderIdReview').val();
        let menuitemId = $(this).attr('data-menuId');
              let data = {};
              let arr = [];
              if ( sessionStorage.getItem("idMenuItemRate") ) {
                arr.push(sessionStorage.getItem("idMenuItemRate"));
                let arrFromSession =  sessionStorage.getItem("idMenuItemRate").split(",");
                if ( arrFromSession.indexOf(menuitemId) == -1 ) {
                  arr.push(menuitemId);
                }
              }else{
                arr.push(menuitemId)
              }

          let sweet, salty , savory , bitter , sour , spicy , presentation , healthy , quantity , valueForPrice , selectedRate ,selectedAll, selectedProtein, selectedHormone, selectedKosher, selectedSugar, price , textReview , starRating ;

          /*--------- LISTENER EVENT ON INPUT-------------*/
          $(`
              .expert-form-${menuitemId} #sweet-rating input[name='expertReview.sweet'],
              .expert-form-${menuitemId} #savory-rating input[name='expertReview.savory'],
              .expert-form-${menuitemId} #salty-rating input[name='expertReview.salty'],
              .expert-form-${menuitemId} #bitter-rating input[name='expertReview.bitter'],
              .expert-form-${menuitemId} #sour-rating input[name='expertReview.sour'],
              .expert-form-${menuitemId} #spicy-rating input[name='expertReview.spicy'],
              .expert-form-${menuitemId} #presentation-rating input[name='expertReview.presentation'],
              .expert-form-${menuitemId} #healthy-rating input[name='expertReview.healthy'],
              .expert-form-${menuitemId} #quantity-rating input[name='expertReview.quantity'],
              .id-${orderId}-${menuitemId} #submitItem .price-slider .flat-slider,
              .id-${orderId}-${menuitemId} .menuItemId-${menuitemId} .setAllPref ,
              .id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.High-Protein"],
              .id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.Hormone-Free"],
              .id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.Kosher - Only cold food"],
              .id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.Less Sugar"],
              .id-${orderId}-${menuitemId} #submitItem .text-review,
              .id-${orderId}-${menuitemId} #submitItem .starRating

            `).on("change paste keyup", function() {

              sweet         =    $(`.expert-form-${menuitemId} #sweet-rating input[name='expertReview.sweet']`).val();
              salty         =    $(`.expert-form-${menuitemId} #salty-rating input[name='expertReview.salty']`).val();
              savory        =    $(`.expert-form-${menuitemId} #savory-rating input[name='expertReview.savory']`).val();
              bitter        =    $(`.expert-form-${menuitemId} #bitter-rating input[name='expertReview.bitter']`).val();
              sour          =    $(`.expert-form-${menuitemId} #sour-rating input[name='expertReview.sour']`).val();
              spicy         =    $(`.expert-form-${menuitemId} #spicy-rating input[name='expertReview.spicy']`).val();
              presentation  =    $(`.expert-form-${menuitemId} #presentation-rating input[name='expertReview.presentation']`).val();
              healthy       =    $(`.expert-form-${menuitemId} #healthy-rating input[name='expertReview.healthy']`).val();
              quantity      =    $(`.expert-form-${menuitemId} #quantity-rating input[name='expertReview.quantity']`).val();
              valueForPrice =    $(`.id-${orderId}-${menuitemId} #submitItem .price-slider .flat-slider`).val();
              selectedAll   =    $(`.id-${orderId}-${menuitemId} .menuItemId-${menuitemId} .setAllPref`).val();
              selectedProtein  =    $(`.id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.High-Protein"]`).val();
              selectedHormone  =    $(`.id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.Hormone-Free"]`).val();
              selectedKosher  =    $(`.id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.Kosher - Only cold food"]`).val();
              selectedSugar =    $(`.id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.Less Sugar"]`).val();
              price         =    $(`.id-${orderId}-${menuitemId} #submitItem .basic-form .slider-price`).text();
              textReview    =    $(`.id-${orderId}-${menuitemId} #submitItem .text-review`).val();
              starRating    =    $(`.id-${orderId}-${menuitemId} #submitItem .starRating`).val();

              selectedRate = [selectedAll,selectedProtein,selectedHormone,selectedKosher,selectedSugar];
              let data = {
                  "sweet"        : sweet,
                  "salty"        : salty,
                  "savory"       : savory,
                  "bitter"       : bitter,
                  "sour"         : sour,
                  "spicy"        : spicy,
                  "presentation" : presentation,
                  "healthy"      : healthy,
                  "quantity"     : quantity,
                  "valueForPrice": valueForPrice,
                  "selectedRate" : selectedRate,
                  "price"        : price,
                  "textReview"   : textReview,
                  "starRating"   :starRating
              }
          /*--------- STORE DATA IN SESSION-----------------*/
           sessionStorage.setItem(`${orderId}_${menuitemId}`, JSON.stringify(data));
          });
          
          /*--------- STORE DATA IN SESSION-----------------*/
          sessionStorage.setItem(`idOrderRate`, orderId);
          sessionStorage.setItem(`idMenuItemRate`, arr);
          reload();
    });



  /**
   * Init Rating Forms
   */
  const $ratingForms = $reviewContainer.find('.ratings-form');


  $ratingForms.each(function () {
    const $this = $(this);
    const isFirstFreeContingent = $this.find("#is-first-free-contingent").val() == 'true';

    // increase form count
    formsLeftUnsaved += 1;

    /**
     * Star Ratings Handler
     */
    $this.find('.starRating').change(function (event) {
      const value = Math.ceil(parseFloat(event.target.value) || 0);
      let label = '';
      let _color = '';
      switch (value) {
        case 1:
          label = "<label class='star-rating-desc'><b><i>So bad I couldn't eat it!</i></b></label>";
          _color = 'rgb(205, 92, 92)';
          break;
        case 2:
          label = "<label class='star-rating-desc'><b><i>Not very good, but I ate it!</i></b></label>";
          _color = 'rgb(238, 173, 14)'
          break;
        case 3:
          label = "<label class='star-rating-desc'><b><i>Worth eating if I'm already at this restaurant!</i></b></label>";
          _color = 'rgb(0, 100, 0)'
          break;
        case 4:
          label = "<label class='star-rating-desc'><b><i>Worth a trip to this restaurant!</i></b></label>";
          _color = 'rgb(0, 139, 69)'
          break;
        case 5:
          label = "<label class='star-rating-desc'><b><i>One of the best I've had!</i></b></label>";
          _color = 'rgb(50, 205, 50)'
          break;
      }
     
      $this.find('.rating-description').html(label);
      $(".star-rating-desc").css({
        "background-color": _color,
        "color":"white"
      });
      setTimeout(function(){
        $(".star-rating-desc").css("background-color",'#fff')
        $(".star-rating-desc").css("color",_color);
      }, 1000);
      updateSocialSharingBtn($this);
    });

    /**
     * Slider setup
     */
    $this.find('.guru-rating-slider').each(function (idx, slider) {
      const $slider = $(slider);
      const id = $slider.data('id');
      const $naCheckbox = $this.find('.' + id + 'NA');

      $slider.on('change', function () {
        $naCheckbox.prop('checked', false);
      });

      $naCheckbox.on('change', function () {
        if ($naCheckbox.prop('checked')) {
          $slider.data('prevValue', $slider.bootstrapSlider('getValue'));
          $slider.bootstrapSlider('setValue', 0);
        } else {
          const value = $slider.data('prevValue');
          $slider.bootstrapSlider('setValue', value || 50);
        }
      });
    });

    function udpate_tree_data(source, udpateInfo){
      if(!_.size(source)) return;
      _.forEach(source,(item,index)=>{
        if(item.key == udpateInfo.key){
          _.forEach(udpateInfo,(value,key)=>{
            item[key] = value;
          })
          return false;
        }
        if(_.size(item.children)) udpate_tree_data(item.children, udpateInfo);
      })
      return
    }

    const renderRatingVenue = function({ customQuery,  formData }){
      $.ajax({
        type: 'POST',
        url: `/ratings/save${customQuery}`,
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(formData)
      }).then(function (response) {
        try{
          let menuitemId     = $this.find(".detailFood").attr('data-menuId');
          sessionStorage.removeItem(`${orderId}_${menuitemId}`)
          $this.fadeOut(function () {
           

            // decrease form count
            formsLeftUnsaved -= 1;
            if(formsLeftUnsaved <= 0){
              $(`#checkout-completed-btn-${orderId}`).hide()
              $(`#rating-section-container-${orderId}`).hide()
            }
            // set rating status for order item
            if (isOrderRating){
              const menuitemId = $this.find("input[name='addonId']").val() || $this.find("input[name='menuItemId']").val();
              const starRating = parseInt($this.find('.starRating').val())
              if(menuitemId) {
                updateOrderItemRating(menuitemId, orderId, 'rated', starRating);
              } else {
              updateOrderRestaurantRating(orderId, 'rated');
              }
            }
            $this.addClass('rated')
            scrollToNextItemRating(orderId);
          });
          if(response.ratingType == 'venue') return;
          let tree_data = $('#tree-data').length && $('#tree-data').val() ? JSON.parse($('#tree-data').val()) : [];
          tree_data = update_tree_data(menuitemId, {
            rating: response.ratedItem[0].average, 
            reviews: response.ratedItem[0].amount
          })
          $('#tree-data').val(JSON.stringify(tree_data))
          dataTree = tree_data;
          __rate_new_item = true;
//below to avoid scroll by getting height and then fixing the height on reload
        let getHight = $("#regular-menu").height();
        // $("#regular-menu").css("min-height",getHight);
        // let updatedHight = $("#regular-menu").height();
        // $("#tree").fancytree("getTree").reload(tree_data)
        //   setTimeout(()=>{
        //     $("#regular-menu").removeAttr("style");
        //   }, 3000);

        //get_all_flavor_match();
        }catch(err){
          console.log(err)
          toastr.error("There are some errors after saving the review.");
        }

      }).catch((error) => {
        console.log('error: ', error);
        if (orderId) {
          $this.find("#submitRatingButton").text("SUBMIT");
          $this.find("#submitRatingButton").prop("disabled", false);
        }
        Swal.fire({
          title: "Error saving ratings",
          text: "Sorry. we encountered an issue saving this item ratings",
          icon: "error",
          allowOutsideClick: true,
          confirmButtonText: "Ok",
          confirmButtonColor: "#3cb371"
        })
      })
    }

    const submitFormData = function (e) {
      const ratingType = $this.data('type');
      let formData = $this.serializeArray();
      const itemSKU = $this.data('item-sku') !=null ? $this.data('item-sku') : null;
      const itemUPC = $this.data('item-upc') !=null ? $this.data('item-upc') : null;
      var orderType = "";
      //var kochavaMobileRedirectLocation='';
      if (orderId) {
        orderType = $(`#collapseCheckout-${orderId}`).data("order-type");
      }
      if(itemSKU) formData.push({ name: 'itemSKU', value: itemSKU });
      if(itemUPC) formData.push({ name: 'itemUPC', value: itemUPC });
      if (ratingType === 'item') {
        formData.push({ name: 'venueId', value: venueId });
        formData.push({ name: 'venueName', value: venueName });
        // formData.push({ name: 'price', value: price });
        if ($('#rate-items').data('reted-time')) {
          formData.push({name: 'reviewNew', value: true})
        }
        $this.find('.guru-rating-slider').each(function (idx, slider) {
          const $slider = $(slider);
          const id = $slider.data('id');
          let na = $this.find('.' + id + 'NA').prop('checked');

          const field = formData.find(function (field) {
            return field.name === slider.name;
          });

          if (field && na) {
            field.value = -1;
          }
        });
        let starRatings = formData.filter((item)=> {  return item.name === "starRating" });
        let starValue=0;
        if(starRatings.length>0 && starRatings[0].value ){
          starValue= starRatings[0].value;
        }
      //  kochavaMobileRedirectLocation = "plateratewebtonative:ratingmenuitems?ratingType="+ratingType+"&rating_value="+starValue+"&orderId="+orderId;
      }
      if (ratingType === 'addon') {
        formData.push({ name: 'venueId', value: venueId });
        formData.push({ name: 'venueName', value: venueName });
      }
      if (ratingType === 'venue' && formData && formData.length) {
        if ($('#restaurantForm').data('reted-time')) {
          formData.push({name: 'reviewNew', value: true})
        }

        let bathroom = '';
        const $checkedBathroom = $this.find("input[name='expertReview.hasBathroom']");
        if(!$checkedBathroom.is(':hidden')) {
          bathroom = $checkedBathroom.is(':checked');
        }

        formData.push({name: 'expertReview.hasBathroom', value: bathroom});
        let starRatings = formData.filter((item)=> {  return item.name === "starRating" });
        let starValue=0;
        if(starRatings.length>0 && starRatings[0].value ){
          starValue= starRatings[0].value;
        }
        if (orderId) formData.push({ name: 'orderId', value: orderId });
        // kochavaMobileRedirectLocation ="plateratewebtonative:ratingRestaurant?ratingType=="+ratingType+"&rating_value="+starValue+"&orderId="+orderId;
      }

      if (orderId) {
        $this.find("#submitRatingButton").text("Calculating your credits...");
        $this.find("#submitRatingButton").prop("disabled", true);
      }

      // Custom query
      let customQuery = '';
      if (orderId) {
        customQuery = `?orderId=${orderId}`;
        let doneExpertReview = $this.find(".expert-review-section").is(":visible");
        customQuery += `&doneExpertReview=${doneExpertReview}`;
        // if(check_iOSapp() || check_androidApp()) {
          // window.location = "plateratewebtonative:expertrestaurantRating?ratingType=="+ratingType+"/venueId="+venueId+"/orderId="+orderId+"";
        // }
      }
      const serviceRating = $('#restaurant-service-serviceRating').val();
      const classyAmbianceRating = $('#restaurant-service-classyAmbianceRating').val();
      const noiseLevelRating = $('#restaurant-service-noiseLevelRating').val();
      const cleanlinessRating = $('#restaurant-service-cleanlinessRating').val();
      const inputBathroomCleanliness = $('#inputBathroomCleanliness').val();
      const totalRating = [ serviceRating,classyAmbianceRating,noiseLevelRating,cleanlinessRating,inputBathroomCleanliness ];
      const defaultRating = Array(5).fill(50);
      const numberOfRating = _.differenceBy(totalRating, defaultRating, Math.floor).length;
      const isRateMoreThanTwoField = numberOfRating >= 2;
      const discountSubmitAmt = $('#discountSubmitAmt').text();
        if(isFirstFreeContingent && ratingType === 'venue') {
          if(numberOfRating < 2 && orderType != 'only_rate'){
            const swalSubmitRatingVenue = function(){
              Swal.fire({
                title: "Don't miss free food",
                text: `If you do an expert restaurant review you'll earn an additional 30% or $${discountSubmitAmt} in free food. Do you want to go back and do an expert restaurant review?`,
                icon: "warning",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: true
              });
            };
            
            swalExtend.call($('#submitRestaurant'), {
              swalFunction: swalSubmitRatingVenue,
              hasCancelButton: true,
              buttonNum: 2,
              buttonColor: [ 'red', 'green' ],
              buttonNames: [ 'No', 'Yes' ],
              classNames: [ 'btn-swal', 'btn-swal' ],
              clickFunctionList: [
                function () { // no
                  if(numberOfRating < 1) {
                    $(`#panelRestaurantRating-${orderId}`).hide();
                    $(`#collapseVenue-${orderId}`).hide();
                    if (isOrderRating){
                      const menuitemId = $this.find("input[name='addonId']").val() || $this.find("input[name='menuItemId']").val();
                      if(menuitemId) {
                        updateOrderItemRating(menuitemId, orderId, 'skipped');
                      } else {
                        updateOrderRestaurantRating(orderId, 'skipped');
                      }
                    }
                  } else {
                    customQuery = `${customQuery}&isRateMoreThanTwoField=${false}`;
                    renderRatingVenue({ customQuery, formData });
                  }
                },
                function () {},
              ]
            });
          } else {
            customQuery = `${customQuery}&isRateMoreThanTwoField=${isRateMoreThanTwoField}`;
            renderRatingVenue({ customQuery,  formData });
          }
        } else {
          customQuery = `${customQuery}&isRateMoreThanTwoField=${ratingType === 'venue' ? isRateMoreThanTwoField : false}`;
          renderRatingVenue({ customQuery,  formData });
        }
    };

    $this.submit(function (event) {
      event.preventDefault();
          if (isOrderRating ) {
            let menuitemId    =    $this.find("input[name='addonId']").val() || $this.find("input[name='menuItemId']").val();
            let sweet         =    $(`.expert-form-${menuitemId} #sweet-rating input[name='expertReview.sweet']`).val();
            let salty         =    $(`.expert-form-${menuitemId} #salty-rating input[name='expertReview.salty']`).val();
            let savory        =    $(`.expert-form-${menuitemId} #savory-rating input[name='expertReview.savory']`).val();
            let bitter        =    $(`.expert-form-${menuitemId} #bitter-rating input[name='expertReview.bitter']`).val();
            let sour          =    $(`.expert-form-${menuitemId} #sour-rating input[name='expertReview.sour']`).val();
            let spicy         =    $(`.expert-form-${menuitemId} #spicy-rating input[name='expertReview.spicy']`).val();
            let presentation  =    $(`.expert-form-${menuitemId} #presentation-rating input[name='expertReview.presentation']`).val();
            let healthy       =    $(`.expert-form-${menuitemId} #healthy-rating input[name='expertReview.healthy']`).val();
            let quantity      =    $(`.expert-form-${menuitemId} #quantity-rating input[name='expertReview.quantity']`).val();
            let valueForPrice =    $(`.id-${orderId}-${menuitemId} #submitItem .price-slider .flat-slider`).val();
            let selectedAll   =    $(`.id-${orderId}-${menuitemId} .menuItemId-${menuitemId} .setAllPref`).val();
            let selectedProtein  =    $(`.id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.High-Protein"]`).val();
            let selectedHormone  =    $(`.id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.Hormone-Free"]`).val();
            let selectedKosher  =    $(`.id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.Kosher - Only cold food"]`).val();
            let selectedSugar =    $(`.id-${orderId}-${menuitemId} .menuItemId-${menuitemId} select[name="dietaryPreferences.Less Sugar"]`).val();
            let price         =    $(`.id-${orderId}-${menuitemId} #submitItem .basic-form .slider-price`).text();
            let textReview    =    $(`.id-${orderId}-${menuitemId} #submitItem .text-review`).val();
            let starRating    =    $(`.id-${orderId}-${menuitemId} #submitItem .starRating`).val();

            let selectedRate = [selectedAll,selectedProtein,selectedHormone,selectedKosher,selectedSugar];
            let data = {
                  "sweet"        : sweet,
                  "salty"        : salty,
                  "savory"       : savory,
                  "bitter"       : bitter,
                  "sour"         : sour,
                  "spicy"        : spicy,
                  "presentation" : presentation,
                  "healthy"      : healthy,
                  "quantity"     : quantity,
                  "valueForPrice": valueForPrice,
                  "selectedRate" : selectedRate,
                  "price"        : price,
                  "textReview"   : textReview,
                  "starRating"   :starRating
            }
            let arr = [];
              if ( sessionStorage.getItem("idMenuItemRate") ) {
                arr.push(sessionStorage.getItem("idMenuItemRate"));
                let arrFromSession =  sessionStorage.getItem("idMenuItemRate").split(",");
                if ( arrFromSession.indexOf(menuitemId) == -1 ) {
                  arr.push(menuitemId);
                }
              }else{
                arr.push(menuitemId)
              }
              sessionStorage.setItem(`${orderId}_${menuitemId}`, JSON.stringify(data));
              sessionStorage.setItem(`idOrderRate`, orderId);
              sessionStorage.setItem(`idMenuItemRate`, arr);
              reload();
      }

     
      var ratingTimeOver = $this.find(".getRatingOver").val();
      if (parseInt($this.find('.starRating').val()) === -1) {
          Swal.fire({
            title: "Star Rating Required!",
            text: "You must submit a star rating to submit a review.",
            icon: "warning",
            confirmButtonText: "Ok",
          }).then((result) => {
          if (result.isConfirmed) {
       
              $('body,html').animate({
                  scrollTop: $this.offset().top
              }, 600);
            }
          });
      } else {
        submitFormData();
      }
    });

    /**
     * Skip Button Handler
     */
    $this.find('.skip-btn').on('click', function (event) {
      TOTAL_RATINGS_CONTAINERS -= 1;
      event.preventDefault();
      const discountRate = $(this).parent().parent().find('.discount-bottom').children().length > 0
      const discountExpertReview = $(this).parent().parent().find('.discount-expert-review').children().length > 0
      let titleSwal = ""
      let textSwal = ""
      let btnCancel = ""
      let btnConfirm = ""
      let btnColors = []
      if (orderId) {
        if (!discountRate && !discountExpertReview) {
          textSwal = "This rating won't be recorded for you, your friends, and family to see how much you liked this menu item!"
          btnConfirm = "No, I won't rate it"
        } else {
          textSwal = "You will not get the credit for free food for your menu item unless you rate it. Do you want to go back and rate it?"
          btnConfirm = "No, I don't want free food"
        }
        titleSwal = "You haven't rated this!"
        btnCancel = "Yes, I will rate it"
        btnColors = ["#d43f3a","mediumseagreen"]
      } else {
        textSwal = "This will mean your review will be lost permanently and nobody else will see it"
        btnCancel = "Cancel"
        titleSwal = "Are you sure you want to skip the review?"
        btnConfirm = "Yes, I am sure!"
        btnColors = ["gray", "orange"]
      }

      const swalSkipReview = function () {
          Swal.fire({
              title: titleSwal,
              text: textSwal,
              icon: "warning",
              allowOutsideClick: true,
              showCancelButton: false,
              showConfirmButton: false
          });
      }
      
      const buttonNames = [btnCancel, btnConfirm];
      const buttonColors = btnColors;
      
      swalExtend.call(this, {
          swalFunction: swalSkipReview,
          hasCancelButton: true,
          buttonNum: 2,
          buttonColor: buttonColors,
          buttonNames: buttonNames,
          classNames: ['btn-swal', 'btn-swal'],
          clickFunctionList: [
              function () { // no
                  if (isOrderRating) {
                      $('body,html').animate({
                          scrollTop: $this.offset().top
                      }, 600);
                  }
              },
              function () { // yes
                  $this.addClass('rated');
                  $this.fadeOut(function () {
                      scrollToNextItemRating(orderId);
      
                      // decrease form count
                      formsLeftUnsaved -= 1;
                      // return to venue page if no ratings are left unsaved
                      if ((!formsLeftUnsaved || $ratingForms.length === 1) && !isOrderRating) {
                          window.location.replace("/restaurant/" + venueId);
                      }
                      // hide Rating Timer
                      if (formsLeftUnsaved <= 0) {
                          $(`#checkout-completed-btn-${orderId}`).hide();
                          $(`#rating-section-container-${orderId}`).hide();
                      }
                      // set rating status for order item
                      if (isOrderRating) {
                          const menuitemId = $this.find("input[name='addonId']").val() || $this.find("input[name='menuItemId']").val();
                          if (menuitemId) {
                              updateOrderItemRating(menuitemId, orderId, 'skipped');
                          } else {
                              updateOrderRestaurantRating(orderId, 'skipped');
                          }
                      }
                  });
              }
          ]
      });
    
    });


    /**
     * Image Upload Setup
     */
    $this.find(`.file-upload`).each(function (idx, fileInput) {
      const check_order = $(this).data('order');
      if(check_order){
        var $progressBar = $this.find(`#progress-bar-${orderId}`);
        var $image = $this.find(`#img-placeholder-${orderId}`);
      }else{
        var $progressBar = $(this).parents('#submitItem').find(`.progress-bar`);
        var $image = $(this).parent().find(`.img-placeholder`);
      }
      $(fileInput).fileupload({
        paramName: 'file',
        pasteZone: null,
        add: function (e, data) {
          if (!$.validateImage({
            name: data.files[0].name,
            size: data.files[0].size
          })) {
            Swal.fire({
              title: "Invalid File Format",
              text: "You can only upload images on JPG, JPEG, PNG, GIF, or BMP formats. Image size less than 50MB",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#3cb371",
            });
          } else {
            $progressBar.addClass('active');
            $progressBar.show();
            RESTAURANT_MOD.resizeImageShow(data);
            // data.submit();
          }
        },
        done: function (e, data) {
          const link = data.result.bucketLink;
          $progressBar.fadeOut();
          $progressBar.removeClass('active');
          $RESIZEIMAGEMODAL.find('.close-modal').trigger('click');
          $this.append(
            $('<input name="imageUrl" type="hidden" value="' + link + '" />'),
            $('<input name="imageTime" type="hidden" value="' + Date.now() + '" />')
          );
          $image.attr('src', link);
          $image.removeClass('no-image');
          //&&&&&&&&&&
          updateSocialSharingBtn($this);
        },
        dataType: 'json',
        url: '/uploadRatingsImage',
        progressall: function (e, data) {
          const progress = parseInt(data.loaded / data.total * 100, 10);

          $progressBar.css({
            width: progress + '%'
          });
          $progressBar.text(progress + '%');

          if (progress === 100) {
            $progressBar.text('Processing image ...');
          }
        }
      })
    });

    // Prevent enter submit handler
    var preventSubmit = function(event) {
      if(event.keyCode == 13) {
          event.preventDefault();
          return false;
      }
    }

    /**
     * User Value Price Slider Setup
     */
    const $itemPrice = $this.find('.item-price');
    const $userValuePrice = $this.find('.user-value-price');
    const $priceValueSlider = $this.find('.price-value-slider');
    const $leftLabel = $this.find('.value-price-slider-label-left');
    const $rightLabel = $this.find('.value-price-slider-label-right');
    let itemmenuType = Number($("#menuType").val() ? $("#menuType").val().trim() :0);
    let userpriceval=0;
    console.log("itemmenuType++++",itemmenuType);
      if(itemmenuType ==1) {
        userpriceval = Number($itemPrice.val());
      } else {
        userpriceval = Number($itemPrice.text());
      }
    // Prevent enter submit on rating price input
    $userValuePrice.keypress(preventSubmit)
    $userValuePrice.val(userpriceval ? userpriceval.toFixed(2) : '0');

    function loadTipPrice (price) {
      const $pricetip = $this.find('.price-slider').find('.min-slider-handle');
      $pricetip.css('position', 'relative');
      $pricetip.html(`<span class="slider-price" style=" position: absolute; top: -20px; font-size: 10px; width: 50px; text-align: center; left: -15px; font-weight: bold; ">${price}</span>`);
    }
    // setTimeout(() => {
    //       loadTipPrice($itemPrice.text() || $itemPrice.val() || 0);
    // }, 1500);

    if ($priceValueSlider) {
      $userValuePrice.on("change paste keyup", function () {
        setTimeout(()=>{
        let currentItemPrice = parseFloat($itemPrice.text() || $itemPrice.val() || 0);
        let userValuePrice = parseFloat($userValuePrice.val() || 0);
        const currentItemMidPrice = currentItemPrice * 0.5;
        let changePercent, sliderScalePercent;
        let sliderValue = 50;
        if (currentItemPrice && userValuePrice) {
          if (currentItemPrice <= -1) {
              userValuePrice = Math.abs(userValuePrice);
              currentItemPrice = Math.abs(currentItemPrice);
          }

          if (userValuePrice <= currentItemPrice) {
            const decrease = currentItemPrice - userValuePrice;

            changePercent = Math.floor((decrease / currentItemPrice) * 100);
            sliderScalePercent = Math.abs(50 - changePercent) + 5;

            //If user price is half or less than current price
            if (userValuePrice <= currentItemMidPrice) {
              sliderValue = 0;
            } else if (sliderScalePercent === 55) {
              sliderValue = 50;
            } else {
              sliderValue = sliderScalePercent;
            }
          } else {
            const increase = userValuePrice - currentItemPrice;

            changePercent = Math.floor((increase / currentItemPrice) * 100);
            sliderScalePercent = (changePercent / 2) + 50;

            if (sliderScalePercent >= 100) {
              sliderValue = 100;
            } else {
              sliderValue = sliderScalePercent;
            }
          }
        }

        $priceValueSlider.bootstrapSlider('setValue', sliderValue).change(function(e) {
          sliderPriceChange(e.value.newValue);
        });
        $userValuePrice.val(userValuePrice ? userValuePrice.toFixed(2) : '');
        loadTipPrice(userValuePrice ? "$"+userValuePrice.toFixed(2) : '');
        }, 1500);
      })

      /*
      *   Setup handler to update left and right labels based on a change in the price
      */
      var updateSliderValue = function (container, value) {
        var valueSlider = $(container).find('.price-value-slider');
        valueSlider.bootstrapSlider('setValue', value);
      }

      let piceItem = parseFloat($itemPrice.text() || $itemPrice.val() || 0).toFixed(2);
      let minUserValuePrice = parseFloat( Math.abs((piceItem / 2)) ).toFixed(2);
      loadTipPrice("$"+piceItem);
      $userValuePrice.val(piceItem);
      // $userValuePrice.attr({
      //   "max" : piceItem * 2,
      //   "min" : minUserValuePrice
      // });
      
      $('.user-value-price').on("change paste keyup", function() {
        let valuePriceItem = parseFloat($(this).val());
        let price = parseFloat($itemPrice.text() || $itemPrice.val() || 0);
        let valueSlide = 0;
        // if(valuePriceItem > piceItem *2){
        //   valuePriceItem = piceItem*2;
        //   // $(this).val((piceItem*2).toFixed(2));
        // }
        loadTipPrice("$"+valuePriceItem.toFixed(2));
        if (valuePriceItem === 0) 
          valueSlide = 0;
        else if (valuePriceItem === piceItem)
          valueSlide = (valuePriceItem/(piceItem*2))*100;
        else if (valuePriceItem === piceItem * 2)
          valueSlide = 100;
        else if (valuePriceItem < piceItem)
          valueSlide = 100* ((valuePriceItem/piceItem) - .5);
        else
          valueSlide = (valuePriceItem/(piceItem*2))*100;
        updateSliderValue($(this).parent().parent(),parseInt(valueSlide));
        $leftLabel.text(`${valuePriceItem < (price/2)  ? '<' : ''} $${price/2}`);
        $rightLabel.text(`$${price*2}${valuePriceItem > (price*2)  ? ' >' : ''}`);
      })

      $itemPrice.on('slide', function(e) {

          // determine left and right labels based on itemPrice
          let halfPrice, doublePrice, currentItemPrice = parseFloat($(this).val() || $(this).attr('placeholder'));
          let sliderVal = parseFloat($priceValueSlider.val()).toFixed(2);

          if (currentItemPrice < -1 || currentItemPrice > 1) {
              // negative or positive integer
              halfPrice = Math.abs(parseFloat(currentItemPrice / 2).toFixed(2));
              doublePrice = Math.abs(parseFloat(2 * currentItemPrice).toFixed(2));

          }
          else {
              // for floating-point values
              halfPrice = parseFloat( Math.abs((currentItemPrice / 2)) ).toFixed(2);
              doublePrice = parseFloat( Math.abs((2 * currentItemPrice)) ).toFixed(2);
          }

          if (sliderVal === 0) {
              let newSliderVal = (Math.abs(currentItemPrice) <= 1 && Math.abs(currentItemPrice) > 0) ? (currentItemPrice/2).toFixed(2) : Math.round(currentItemPrice/2);
              $userValuePrice.val(newSliderVal);
          }
          else if (sliderVal === 50)
              $userValuePrice.val(currentItemPrice);
          else if (sliderVal === 100)
              $userValuePrice.val(currentItemPrice * 2);
          else if (sliderVal < 50)
              $userValuePrice.val(currentItemPrice * ((sliderVal/100) + .5));
          else
              $userValuePrice.val(currentItemPrice *
                                          (1 + (((sliderVal - 50) * 2)/100))
                                      );

          halfPrice = halfPrice && !isNaN(Number(halfPrice)) ? Number(halfPrice).toFixed(2) : 0;
          doublePrice = doublePrice && !isNaN(Number(doublePrice)) ? Number(doublePrice).toFixed(2) : 0;
          $leftLabel.text(`$${halfPrice}${currentItemPrice < 0 ? ' off' : ''}`);
          $rightLabel.text(`$${doublePrice}${currentItemPrice < 0 ? ' off' : ''}`);
          loadTipPrice("$"+ currentItemPrice);
      });

      /*
      * Update "wlling to pay" input value when the user moves item worth slider
      */
      // $priceValueSlider.on('slide', function (e) {

      //     // get the value from the input correspondng to the slider
      //     let sliderVal = parseInt($(this).val());
      //     let price = parseFloat($itemPrice.text() || $itemPrice.val() || 0);
      //     let halfPrice = Math.floor(price/2);
      //     let userVal = 0;
      //     // update the val inside the "would pay" element
      //     if (sliderVal === 0) {
      //         userVal = "$"+ parseFloat(price/2).toFixed(2);
      //     } else if (sliderVal === 100) {
      //         userVal = "$"+ parseFloat(price * 2).toFixed(2);
      //     } else if (sliderVal === 50) {
      //         userVal = "$"+ parseFloat(price).toFixed(2);
      //     } else if (sliderVal < 50) {
      //         userVal = "$"+ parseFloat(price * (0.5 + sliderVal/100)).toFixed(2);
      //     } else if (sliderVal > 50) {
      //         // if value user would pay is greater than the actual price
      //         // then we need to multiply the "difference" by 2 because
      //         // each pixel of the latter half of the slider is worth 2 percentage points
      //         userVal = "$"+ parseFloat(price * (1 + ((sliderVal - 50) * 2)/100)).toFixed(2);
      //     }
      //     $userValuePrice.val(Number(userVal.replace(/[^a-z0-9\s.]/gi, '')));
      //     loadTipPrice(userVal);
      // })

      function sliderPriceChange (sliderVal) {

        let price = parseFloat($itemPrice.text() || $itemPrice.val() || 0);
        let userVal = 0;

        // update the val inside the "would pay" element
        if (sliderVal === 0) {
            userVal = price/2;
        } else if (sliderVal === 100) {
            userVal = price * 2;
        } else if (sliderVal === 50) {
            userVal = price;
        } else if (sliderVal < 50) {
            userVal = price * (0.5 + sliderVal/100);
        } else if (sliderVal > 50) {
            userVal = price * (1 + ((sliderVal - 50) * 2)/100);
        }
        $userValuePrice.val(parseFloat(userVal).toFixed(2));
        loadTipPrice("$"+ parseFloat(userVal).toFixed(2));
        $leftLabel.text(`${userVal < (price/2)  ? '<' : ''} $${price/2}`);
        $rightLabel.text(`$${price*2}${userVal > (price*2)  ? ' >' : ''}`);
      };

      $('.user-value-price').trigger('change');
    }
  });

  if (!orderId){
    const $restaurantForm = $('#restaurantForm');
    const $restaurantFormHeader = $restaurantForm.find('.panel-title a');
    const $restaurantFormBody = $restaurantForm.find('#collapseVenue');
    if ($ratingForms.length === 1) {
      $restaurantFormBody.collapse('show');
    } else {
      if ($restaurantForm.data('rated-24h')) {
        const origTitle = $restaurantFormHeader.text();
        $restaurantFormHeader.text('Rate Restaurant Again');
        $restaurantFormHeader.one('click', function() {
          $restaurantFormHeader.text(origTitle);
        });
        $restaurantFormBody.collapse('hide');
      }
    }
  }
  //Keep count of container loaded for rating, init with 1 includes restaurant rating container
  let TOTAL_RATINGS_CONTAINERS = 0;
  $(".menuItemContainers").each(function (index, container) {
    TOTAL_RATINGS_CONTAINERS += 1;
    var CURRENT_CONTAINER = "#menuItemContainer" + index;
    var CURRENT_INDEX = index;


    /*
    *    Setup handlers to update user's diet preferences
    */

    $(CURRENT_CONTAINER).find('#meetsAllDietPreferences').on('click', function (event) {
      event.preventDefault();
      var $dietPrefsOptions = $(CURRENT_CONTAINER).find('.dietPrefsOptions');
      $dietPrefsOptions.each(function (option) {
        //Sets option to 'Yes'
        $($dietPrefsOptions[option][1]).prop('selected', true);
      });
    });
  }); //End menuItem container handlers

  /**
   * Open to rate
   */
//commented by 76east  $('body').on('click', '.order-item-rating-accordion', function(){
//    const collapsed = $(this).find('a').hasClass('collapsed');
  $(document).on('click','.detailFood',function(){
    const collapsed = $(this).attr('aria-expanded');
    if(collapsed.trim()=="true") {
       $(this).find('.btn-open-rate').text('')
      $(this).find('.btn-open-rate').text('Close')
    } else {
      $(this).find('.btn-open-rate').text('')
      $(this).find('.btn-open-rate').text('Open to rate')
    }
  });
	
  /*
  * 	display food form handler
  */

  $('.food-display').click(function (e) {
    $('.wine-form').slideUp();
    $('.food-form').slideDown();
  })

  /*
  *   display wine form handler
  */

  $('.wine-display').click(function () {
    $('.food-form').slideUp();
    $('.wine-form').slideDown();
  })

  $('.wine-beginner-btn').click(function () {
    $('.wine-intermediate').slideUp();
    $('.wine-advanced').slideUp();
    $('.wine-beginner').slideDown();
  })

  $('.wine-intermediate-btn').click(function () {
    $('.wine-beginner').slideUp();
    $('.wine-advanced').slideUp();
    $('.wine-intermediate').slideDown();
  })

  $('.wine-advanced-btn').click(function () {
    $('.wine-beginner').slideUp();
    $('.wine-intermediate').slideUp();
    $('.wine-advanced').slideDown();
  })

  var wineSense;

  $('.flavorwheel-sight-btn').click(function () {
    wineSense = 'sight';
    $('.flavorwheel-smell').slideUp();
    $('.flavorwheel-taste').slideUp();
    $('.flavorwheel-sight').slideDown();
  })

  $('.flavorwheel-smell-btn').click(function () {
    wineSense = 'smell';
    $('.flavorwheel-sight').slideUp();
    $('.flavorwheel-taste').slideUp();
    $('.flavorwheel-smell').slideDown();
  })

  $('.flavorwheel-taste-btn').click(function () {
    wineSense = 'taste';
    $('.flavorwheel-sight').slideUp();
    $('.flavorwheel-smell').slideUp();
    $('.flavorwheel-taste').slideDown();
  })

  $('.wineType1').click(function () {
    $('.winedata2').not($(this).parent().children('.winedata2')).slideUp();
    $('.winedata3').slideUp();
    $(this).parent().children('.winedata2').slideToggle();
    //  if ($(this)[0].children[0].innerHTML==='+') {
    //      $(this)[0].children[0].innerHTML='-';
    //  } else if ($(this)[0].children[0].innerHTML==='-') {
    //      $(this)[0].children[0].innerHTML='+';
    //  }
  })

  $('.wineType2').click(function () {
    $('.winedata3').not($(this).parent().children('.winedata3')).slideUp();
    $(this).parent().children('.winedata3').slideToggle();
    //   if ($(this)[0].children[0].innerHTML==='+') {
    //       $(this)[0].children[0].innerHTML='-';
    //   } else if ($(this)[0].children[0].innerHTML==='-') {
    //       $(this)[0].children[0].innerHTML='+';
    //   }
  })

  $('.addBtn1').click(function () {
    if (wineSense === 'sight') {
      $('#sightReview').append($(this).parent().children('.wineType1')[0].firstChild.data + ', ');
    } else if (wineSense === 'smell') {
      $('#smellReview').append($(this).parent().children('.wineType1')[0].firstChild.data + ', ');
    } else if (wineSense === 'taste') {
      $('#tasteReview').append($(this).parent().children('.wineType1')[0].firstChild.data + ', ');
    }
  })

  $('.addBtn2').click(function () {
    if (wineSense === 'sight') {
      $('#sightReview').append($(this).parent()[0].firstChild.firstChild.data + ', ');
    } else if (wineSense === 'smell') {
      $('#smellReview').append($(this).parent()[0].firstChild.firstChild.data + ', ');
    } else if (wineSense === 'taste') {
      $('#tasteReview').append($(this).parent()[0].firstChild.firstChild.data + ', ');
    }
  })
  /**
   * GURU REVIEWS HANDLERs
   */
  /*let GURU_RATINGS_CHANGED = 0;
  $('.guru-rating-slider').on('change', function (event) {
    var $thisSlider = $(event.target);
    if (!($thisSlider.hasClass('ratingChanged'))) {
      //Add 'ratingChanged' class to detect when slider values have been updated
      $thisSlider.addClass('ratingChanged');
      GURU_RATINGS_CHANGED += 1;
    }
  });

  // Handle clicks on Guru Review Preferences  N/A Checkboxes
  $(".item-prefs-rating-na-btn").click(function () {
    var $parentContainer = $(this).parent().parent().parent();
    var $rangeSlider = $parentContainer.find('.flat-slider').bootstrapSlider();
    var parentContainerId = $parentContainer.attr('id');
    $rangeSlider.addClass('ratingChanged');
    // Check if the N/A button is checked
    if ($(this).is(':checked')) {
      $(parentContainerId.concat(' .slider-handle')).hide();
      $(parentContainerId.concat(' .slider-selection')).hide();
      $rangeSlider.bootstrapSlider('disable');
      $rangeSlider.bootstrapSlider('setValue', 100);
      $rangeSlider.addClass('na-slider');
    } else {
      $(parentContainerId.concat(' .slider-handle')).show();
      $(parentContainerId.concat(' .slider-selection')).show();
      $rangeSlider.bootstrapSlider('enable');
      $rangeSlider.bootstrapSlider('setValue', 50);
      $rangeSlider.removeClass('na-slider');
    }
    GURU_RATINGS_CHANGED += 1;
  });*/

  /*
  *   Retrieve all guru ratings
  */
  const getGuruRatings = (parentContainer) => {
    //Get the current restaurant slider ratings elements
    let guruRatings = {};
    const guruSliders = [
      { "sweet": $("#sweet") },
      { "salty": $("#salty") },
      { "savory": $("#savory") },
      { "bitter": $("#bitter") },
      { "presentation": $("#presentation") },
      { "spicy": $("#spicy") },
      { "healthy": $("#healthy") },
      { "quantity": $("#quantity") },
      { "sour": $("#sour") },
    ];
    guruSliders.forEach(function (rating) {
      let key = Object.keys(rating);
      let $slider = $(parentContainer).find((rating[key]));
      if ($('#' + key + 'NA').prop('checked') || $slider.hasClass('na-slider')) {
        guruRatings[key] = -1;
      } else {
        guruRatings[key] = parseInt($slider.val());
      }
    });
    return guruRatings;
  };

  /*
  *   toggle expert review form handler
  */

 $reviewContainer.find('.toggle-expert-review').click(function (e) {
    var expertText = "Expert Review";
    var basicText = "Basic Review";
    var currentText = $(this).text().trim();
    var targetForm = $(this).attr('data-target');
    // toggle text
    // toggle expert form
    if (currentText === expertText) {
      // open expert form
      $(this).text(basicText);
      $(targetForm).slideDown();
    } else {
      // close expert form
      $(this).text(expertText);
      $(targetForm).slideUp();
    }
    e.preventDefault();
  });
  /*
  *   Restaurant rating slider handler
  */
  /*let RESTAURANT_RATINGS_CHANGED = 0;
  $('.restaurant-rating-slider').on('change', function (event) {
    var $thisSlider = $(event.target);
    if (!($thisSlider.hasClass('ratingChanged'))) {
      //Add 'ratingChanged' class to detect when slider values have been updated
      $thisSlider.addClass('ratingChanged');
      RESTAURANT_RATINGS_CHANGED += 1;
    }
  });*/
  /*var getRestaurantRatings = function () {
      var restaurantRating = {
        "venueId": $('#restId').val(),
        "venueName": $('#venueName').val(),
        "review": $("#restaurant-review").val()
      };
      //Get the current restaurant slider ratings elements
      var sliderRatings = [
        { "serviceRating": $("#restaurant-service") },
        { "ambienceRating": $("#restaurant-ambience") },
        { "noiseLevelRating": $("#restaurant-noise") },
        { "cleaninessRating": $("#restaurant-cleanliness") },
        { "classyAmbianceRating": $("#restaurant-classy-ambience") }
      ];

      sliderRatings.forEach(function (rating) {
        //Get the slider ratings keys
        var key = Object.keys(rating);
        //Get the slider element from the DOM
        var $slider = $(rating[key]);

        if ($slider.hasClass('ratingChanged') || RESTAURANT_RATINGS_CHANGED >= 2) {
          //Set the current slider rating value;
          restaurantRating[key] = parseInt($slider.val());
          // } else {
          //     restaurantRating[key] = -1;
        }
      });

      return restaurantRating;
    };*/

  /*
  *
  * Update the value slider
  * Container: A parent element from the value slider
  */

  var submitDietPreferences = function (parentContainer) {
    var dietPreferences = getAllSelectedDietPreferences(parentContainer);
    const entryId = $(parentContainer).find("#itemId").val().trim();
    const data = {
      preferences: dietPreferences.preferences,
      entryId: entryId
    };

    $.ajax({
      url: '/rating/editDietPreferences',
      method: 'POST',
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(data),
      dataType: 'json',
      error: function (err) {
        console.log('Error submitting diet preferencs', err)
      }
    }).then(function (data) {
      console.log('Submitted diet preferences', data);
    });
  };

  var getAllSelectedDietPreferences = function (parentContainer) {
    var selectedOptions = { "preferences": [] };
    //Gets all the options selected in the current prefs container
    $(parentContainer).find('.dietPrefsOptions option:selected').each(function (index, option) {
      var selectedOption = JSON.parse(option.value);
      selectedOptions.preferences.push({
        name: selectedOption.name,
        value: selectedOption.value
      });
    });
    return selectedOptions;
  };

  var setAllDietPrefs = function (element) {
    let menuItemId = element.data('menuitemid');
    let _parent = $('.pref-'+menuItemId);
    _parent.find('select.dietary-preferences').each(function() {
        $(this).val(element.val());
    });
  }

  // set Order Item Rating Status
  const updateOrderItemRating = (menuItemId, orderId, status = "not-rated", starRating = 0) => {
    let user_id = $('#userId').val();
    return $.promisedAjax({
      url: `/orders/updateOrderItemRating`,
      type: 'POST',
      data: JSON.stringify({
        "menuItemId": menuItemId,
        "orderId"   : orderId,
        "status"    : status,
        "rating"    : starRating,
        "user_id" : user_id
      }),
      contentType: 'application/json',
      dataType: 'json'
    }).then((res) => {
      const totalNotRatedItems = $(`#rating-section-${orderId}`).find(".ratings-form:visible").length;
      let tipLater = $(`#order-checkout-${orderId} #tip-later-${orderId}`).val()
      if (totalNotRatedItems <= 0){
        $(`#rating-section-container-${orderId}`).hide()
        if (tipLater == 'later'){
          Swal.fire({
            title: "Please pay your tip!",
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "Ok",
            confirmButtonColor: "#3cb371",
            closeOnCancel: true
          }).then((result) => {
          if (result.isConfirmed) {
       
            $('html, body').animate({
              scrollTop: $(`#order-checkout-totals-${orderId}`).offset().top
            }, 1000);
          }
          });
        }
      }
    }).catch((err) => {
      return err
    })
}

  // set Order Restaurant Rating Status
  const updateOrderRestaurantRating = (orderId, status = "not-rated") => {
    return $.promisedAjax({
      url: `/orders/updateOrderRestaurantRating`,
      type: 'POST',
      data: JSON.stringify({
        "orderId"   : orderId,
        "status"    : status,
      }),
      contentType: 'application/json',
      dataType: 'json'
    }).then((res) => {

      return res;
    })
    .catch((err) => {
      return err;
    })
  };

  //Scroll screen rating
  const scrollScreenRating = ($ccreen) => {
    try {
      let _t = $ccreen.offset().top;
      let _h = $ccreen.height();
      let _scr = $(window).height();
      let _position = (_t + _h)-_scr;
      $('html, body').animate({ scrollTop: _position + 30 }, 0);
    } catch (error) {

    }
  }

  $('.setAllPref').change(function () {
    setAllDietPrefs($(this));
  })

  $('#hasBathroom').on('change', function () {
    if($(this).is(":checked")) {
      $('#bathroomCleanliness').slideDown('slow');
      $('#inputBathRoom').attr('disabled', false);
    } else {
      $('#bathroomCleanliness').slideUp('slow');
      $('#inputBathRoom').attr('disabled', true);
    }
  })

  $reviewContainer.find('#guru-view').on('click', function(){
    var changeText = $(this);
    $reviewContainer.find('#guru-view-rate').toggle('slow', function() {
      if ($(this).is(':hidden')) {
        changeText.html('<u>Expert review</u>');
        $(this).find('input').attr('disabled', true);
        if ($reviewContainer.find('#hasBathroom').is(":checked")) {
          $reviewContainer.find('#inputBathRoom').attr('disabled', false);
        } else {
          $reviewContainer.find('#inputBathRoom').attr('disabled', true);
        }
      } else {
        changeText.html('<u>Basic review</u>');
        if ($reviewContainer.find('#hasBathroom').is(":checked")) {
          $reviewContainer.find('#bathroomCleanliness').show();
        } else {
          $reviewContainer.find('#bathroomCleanliness').hide();
        }
        $(this).find('input').attr('disabled', false);
      }
    });
  })
  //
  $('.edit-review-item').on('click',function(e){
    let user_id = $('#userId').val();
    if(user_id) user_id = user_id.trim();
    if($(this).data('userid') != user_id){
      toastr.error("This review isn't belong to you");
      return
    }
    let reviewid = $(this).data('reviewid');
    let info_item = $('#'+reviewid).text();
    let item = '';
    try {
      item = JSON.parse(info_item);
    } catch (error) {
      return
    }
    if(!item){
      return
    }
    info_menuitem_review(item);
  })
  $('#review-modal').on('click', '.upload-image-ratings-btn', function () {
    $('#fileInputModal').click();
  })
  $('.save-item-ratings-btn').on('click', function(e) {
    e.preventDefault();
    //Find the parent div containing this modal content
    let modalRiviewInfo = $(`#review-modal`);
    //Get the item data
    var updateItemData = {
        entryId : modalRiviewInfo.find('.entry-id').val().trim(),
        venueId : $.trim(modalRiviewInfo.find('.venueId-id').val()),
        menuItemId : $.trim(modalRiviewInfo.find('.menuitemId-id').val()),
        menuPrice : $.trim(modalRiviewInfo.find('.price-menu-input').val()),
        name : modalRiviewInfo.find('.rated-item-name').text().trim(),
        venueName : modalRiviewInfo.find('.rated-venue-name').text().trim(),
        itemPrice: modalRiviewInfo.find('.rated-item-price').val(),
        editedStarRating : modalRiviewInfo.find('.ratebox_item').val(),
        editedReview : modalRiviewInfo.find('.item-review').val().trim(),
        valueForPrice : modalRiviewInfo.find('[name="ValueForPrice"]').val(),
        userValuePrice : modalRiviewInfo.find('[name="userValuePrice"]').val(),
        sweetValue : modalRiviewInfo.find('input[name="sweet"]').val(),
        saltyValue : modalRiviewInfo.find('input[name="salty"]').val(),
        savoryValue : modalRiviewInfo.find('input[name="savory"]').val(),
        bitterValue : modalRiviewInfo.find('input[name="bitter"]').val(),
        sourValue : modalRiviewInfo.find('input[name="sour"]').val(),
        spicyValue : modalRiviewInfo.find('input[name="spicy"]').val(),
        presentationValue : modalRiviewInfo.find('input[name="presentation"]').val(),
        healthyValue : modalRiviewInfo.find('input[name="healthy"]').val(),
        quantityValue : modalRiviewInfo.find('input[name="quantity"]').val()
    };
    if(!updateItemData.menuPrice && $(modalRiviewInfo).find('.price-menu-text').length) updateItemData.menuPrice = $(modalRiviewInfo).find('.price-menu-text').text() || 0;

    //Send data to update
    $.ajax({
      url: '/users/profile/editPastReviews',
      method: 'POST',
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(updateItemData),
      error: function(err) {
          alert('We encountered a problem updating rating');
      }
    }).then(function(data) {
      let itemId = $(`#review-modal`).find('#review_id').val();
      let review_update = $('#item-review-'+itemId);
      review_update.find('.media-heading .orange').text((new Date).toString().slice(0, 15));
      review_update.find('.ratebox').attr('data-rating',updateItemData.editedStarRating);
      review_update.find('p span').text(updateItemData.editedReview);
      review_update.find('.ratebox').raterater({
        isStatic : true,
        allowChange: false
      });
      // update_review in client
      let data_review = JSON.parse($('#'+itemId).text().trim()||'{}');
      data_review.valueForPrice = updateItemData.valueForPrice;
      data_review.userValuePrice = updateItemData.userValuePrice;
      data_review.starRating = updateItemData.editedStarRating;
      data_review.review = updateItemData.editedReview;
      data_review.imageUrls.unshift({
        url:$('#carousel-image-0').attr("data-url-link"),
        uploadedDate:new Date()
      });
        $('#'+itemId).text(JSON.stringify(data_review));
        modalRiviewInfo.modal('hide');
        toastr.success("Edit review successfully");
    });
  });

  $(".del-image-ratings-btn").on('click', function (e) {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this image",
      icon: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn-danger",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#8B0000",
    }).then((result) => {
      if (result.isConfirmed) {
        const imContainerId = $(e.target).attr('data-container-id');
        const RatingID = $(e.target).attr('data-type');
        const carouselId = $(e.target).attr('data-carousel-id');
        const image_itemId =  $(imContainerId).find("#itemId").val();
        let carouselItemActive = $(carouselId).find('.active');
        let carouselIdActive = $(carouselItemActive).attr('id');
        let urlDelIndex = $(carouselItemActive).attr('data-url-index');
        let urlDelLink = $(carouselItemActive).attr('data-url-link');
        let imageIdStart = urlDelLink.lastIndexOf('/') +1;
        let imageId = urlDelLink.slice(imageIdStart);
        const delData = { key : imageId };
        delData.itemId = image_itemId;
        delData.url = urlDelLink;
        if (RatingID == 'RatingID') delData.imageType = "RatingID";
        $.post('/deleteImage', delData, function(res) {
          let itemId = $(`#review-modal`).find('#review_id').val();
          let info_review = JSON.parse($('#'+itemId).text().trim()||'{}');
          let list_imgs = info_review.imageUrls;
          info_review.imageUrls = _.remove(list_imgs, function(ele) {
            return ele.url != urlDelLink;
          });
          if(info_review.imageUrls.length){
            let img_link = info_review.imageUrls[0].url;
            $('#item-review-'+itemId).find('img').attr('src',img_link);
          }else{
            $('#item-review-'+itemId).find('img').attr('src','/images/tempfood.png');
          }
          $('#'+itemId).text(JSON.stringify(info_review))

          carouselItemActive.remove();
          if ($(carouselId).find('.item').length){
            let carouselNextElement = $(carouselId).find('.item').first();
            carouselNextElement.addClass('active');
          } else {
            const idInputFile = $(imContainerId).find('input[name="file"]').attr('id');
            $(imContainerId).find('.item-image-carousel').html(`<div id="carousel-image-0" data-url-index="0"  data-url-link="/images/tempfood.png" class="item active default"><label for="${idInputFile}"><img class="carousel-image" style="width:100%" src="/images/tempfood.png"/></label></div>`)
            $(imContainerId).find('.imageDelete').hide();
          }

          Swal.fire("Deleted!", "Your image has been deleted.", "success");
        })
        .catch(function(error) {
            console.log("error", error);
            Swal.fire({
                title: "Unable to Delete Image",
                text: "We had a problem deleting this image.",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#3cb371",
            });
        });

      }
    });


  });
  $(document).ready(function(){
    let user_id = $('#userId').val();
    if(user_id) user_id=user_id.trim();
    $('.edit-review-item').each(function(){
      if($(this).data('userid') != user_id){
        $(this).remove();
      }
    })
  })
  function info_menuitem_review(item){

    let $container            = $(`#review-modal`);
    let $ratedEntryId         = $container.find('.entry-id');
    let $ratedvenueIdId       = $container.find('.venueId-id');
    let $menuitemId           = $container.find('.menuitemId-id');
    let $ratedItemName        = $container.find('.rated-item-name');
    let $menuPrice            = $container.find('.menu-price');
    let $menuPriceIdValue     = $container.find('#menuprice');
    let $ratedItemPrice       = $container.find('.rated-item-price');
    let $ratedVenueName       = $container.find('.rated-venue-name');
    let $editItemReview       = $container.find('.item-review');
    let $editItemRatebox      = $container.find('.edit-item-ratebox-one');
    let $valueForPrice        = $container.find('.value-for-price');
    let $expertReview         = $container.find('.expert-form-one');
    let $reviewimageCarousel        = $container.find('.item-image-carousel');
    let $buttonEdit           = $container.find('.imageDelete');
    $container.find('#review_id').val(item._id);
    sliderHtml
    $ratedEntryId.val(item._id);
    $ratedvenueIdId.val(item.venueId || '');
    $menuitemId.val(item.menuItemId || '');
    $menuPriceIdValue.val(item.price || null);

    $ratedItemName.html('');
    $ratedItemName.text(item.menuItemName);
    $ratedItemName.attr("href", `/restaurant/${item.venueId}?menuItem=${item.menuItemId}`);
    if(item.menuType == 1) $menuPrice.html(`<input name="price" type="number"
    class="price price-menu-input item-price green"
    min="0.00" step="0.01" max="2500.00"
    value="${item.price || 0.00}" />`);
    else $menuPrice.html(`<input type="number" class="price-text price-menu-text item-price green" name="price" value="${item.price || 0.00}" />`);
    $ratedItemPrice.text(`${(item.userValuePrice && !isNaN(item.userValuePrice)) ? "$" + item.userValuePrice : '' }`);
    $ratedItemPrice.val(item.userValuePrice);

    $ratedVenueName.text(item.venueName);
    $ratedVenueName.attr("href", `/restaurant/${item.venueId}`);

    $editItemRatebox.parent().find('div').remove();
    $editItemRatebox.val(item.starRating);


    $editItemReview.val(item.review);

    $valueForPrice.val((item.valueForPrice && !isNaN(item.valueForPrice)) ? item.valueForPrice : 50);
    $valueForPrice.attr('data-slider-value', (item.valueForPrice && !isNaN(item.valueForPrice)) ? item.valueForPrice : 50);

    const expertReview = item.expertReview;

    $expertReview.html('');
    let review = '';
    if (expertReview) {
      let otherHtml = `<div class="text-quantities row">
                            <p class="col col-xs-4 ">tiny portion</p>
                            <p class="col col-xs-4 text-center ">medium portion</p>
                            <p class="col col-xs-4 text-right ">2+ meals</p>
                        </div>`
      review = sliderHtml({title: 'Sweet', minText: 'Low', maxText: 'High', value: expertReview.sweet, enabled: true, name: 'sweet' })
      review = review + sliderHtml({title: 'Salty', minText: 'Low', maxText: 'High', value: expertReview.salty, enabled: true, name: 'salty' })
      review = review + sliderHtml({title: 'Unami (meaty taste)', minText: 'Low', maxText: 'High', value: expertReview.savory || 0, enabled: true, name: 'savory' })
      review = review + sliderHtml({title: 'Bitter', minText: 'Low', maxText: 'High', value: expertReview.bitter, enabled: true, name: 'bitter' })
      review = review + sliderHtml({title: 'Sour', minText: 'Low', maxText: 'High', value: expertReview.sour, enabled: true, name: 'sour'})
      review = review + sliderHtml({title: 'Spicy', minText: 'Low', maxText: 'High', value: expertReview.spicy, enabled: true, name: 'spicy',})
      review = review + sliderHtml({title: 'Presentation', minText: 'Low', maxText: 'High', value: expertReview.presentation, enabled: true, name: 'presentation'})
      review = review + sliderHtml({title: 'Healthy', minText: 'Low', maxText: 'High', value: expertReview.healthy, enabled: true, name: 'healthy'})
      review = review + sliderHtml({title: 'Portion Size', minText: 'Low', maxText: 'High', value: expertReview.quantity,  enabled: true, name: 'quantity', otherHtml})
    }


    $expertReview.append(review);
    $reviewimageCarousel.html(`<div id="carousel-image-0" data-url-index="0"  data-url-link="/images/tempfood.png" class="item active default">
                                    <label for="fileInputModal"><img class="carousel-image" style="width:100%" src="/images/tempfood.png"/></label>
                                </div>`);
    if (item.imageUrls && item.imageUrls.length > 0) {
      // let current_img = [];
      // current_img.push({
      //   url:$('#item-review-'+item._id).find('img').attr("src"),
      //   uploadedDate:new Date()
      // })
      let img_slide = listimage(item.imageUrls);
      if (item.imageUrls.length > 1) {
        img_slide = img_slide +`
            <a class="carousel-control-prev" href="#reviewimageCarousel" role="button" data-slide="prev">
              <span class="fas fa-chevron-left" aria-hidden="true"></span>
              <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" href="#reviewimageCarousel" role="button" data-slide="next">
              <span class="fas fa-chevron-right" aria-hidden="true"></span>
              <span class="sr-only">Next</span>
            </a>
        `;
      }
      $reviewimageCarousel.html(img_slide);
      $buttonEdit.show();

      // $imageSlide.html(img_slide);
    } else {
      $buttonEdit.hide();
    }
    updateStar();
    $container.find('.flat-slider, .value-for-price').bootstrapSlider({
      min: 0,
      max: 100,
      tooltip: 'hide',
      formatter: function (value) {
        return;
      }
    });
    $('#review-modal').modal('show');
  }
  function sliderHtml(obj) {
    if ((!obj.value || obj.value === -1 || obj.value === null || isNaN(Number(obj.value)))) {
      let notset = `<div class="row">
                      <div class="col-xs-12 col-sm-3 col-md-4">
                        <p for="">${obj.title}</p>
                      </div>
                      <div class="col-xs-12 col-sm-9 col-md-8">
                        <p class="text-center"><span>Not rated</span></p>
                      </div>
                    </div>
                    `
      return notset;
    }
    return `
    <div class="row">
      <div class="col-xs-12 col-sm-3 col-md-4">
        ${obj.title == 'Service' ? `<label>${obj.title}</label>` : `<p for="">${obj.title}</p>`}
      </div>

      <div class="col-xs-12 col-sm-9 col-md-8">
        <div class="row" style="margin-top:5px">
          <div class="col-xs-2"><span>${obj.minText}</span></div>
          <div class="col-xs-7">
            <input class="flat-slider"
              type="number"
              name="${obj.name || 'slider'}"
              value="${obj.value}"
              data-id="${obj.name}"
              data-slider-min="0"
              data-slider-max="100"
              data-slider-step="5"
              data-slider-value="${obj.value}"
              data-slider-enabled="${obj.enabled || false}"/>
              ${obj.otherHtml || ''}
          </div>
          <div class="col-xs-3"><span>${obj.maxText}</span></div>
        </div>
      </div>
    </div>
    `
  }
  const listimage = function (imageUrls) {
    let htmlimage = ''
    imageUrls.forEach(function (image, ind) {
      if (image.url !== null) {
        if (ind === 0) {
          htmlimage = htmlimage + `<div id = "carousel-image-${ ind }" data-url-index= "${ ind }"  data-url-link= "${ image.url }" class="carousel-item active">
                        <label for="fileInputModal"><img class="carousel-image" src="${ image.url }"/></label>
                    </div>`
        } else {
          htmlimage = htmlimage + `<div id = "carousel-image-${ ind }" data-url-index= "${ ind }"  data-url-link= "${ image.url }" class="carousel-item">
                        <label for="fileInputModal"><img class="carousel-image" data-Url-index="${ ind }" src="${ image.url }"/></label>
                    </div>`
        }
      }
    })
    return htmlimage;
  }
  function updateStar(){
    $('.rated-item-ratebox').raterater({
      isStatic : true,
      allowChange: false
    });
    $('.edit-item-ratebox-one').raterater({
        mode : 'input',
        allowChange: true,
        isStatic: false,
    });
  }
  initFileUpload('#fileInputModal')
  function initFileUpload(fileInput) {
      $(fileInput).fileupload({
            paramName: 'file',
            dataType: 'xml',
            add: addImageUpload,
            done: imageUploadDone,
            //maxFileSize: 1048576, //1MB,
            progressall: function (e, data) {
              const containerId = $(e.target).attr('data-container-id');
              let progress = parseInt(data.loaded / data.total * 100, 10);
              $(containerId).find('#progress .bar').css(
                  'width',
                  progress + '%'
              );
          }
      })
  }
  function addImageUpload(e, data) {
      const imageData = {
          name : data.files[0].name,
          size : data.files[0].size,
      };

      if ($.validateImage(imageData)) {
          $.ajax({
              url: '/s3_credentials',
              type: 'GET',
              dataType: 'json',
              data: { filename: imageData.name },
              success: function(s3Data) {
                  data.url = s3Data.endpoint_url;
                  data.formData = s3Data.params;
                  data.submit();
              }
          });
      } else {
          Swal.fire({
              title: "Image Validation failed",
              text: "You can only upload images on JPG, JPEG, PNG, GIF, or BMP formats. Max image size is 1GB.",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#3cb371",
          });
      }
  }
  function imageUploadDone(e, data) {
      const containerId = $(e.target).attr('data-container-id');
      const itemId =  $(`#review-modal`).find('#review_id').val();
      const imageUrl = $(data.jqXHR.responseXML).find('Location').text();
      const postData = { url : imageUrl };
      const uploadImgeInputId = $(e.target).attr('id');

      if (uploadImgeInputId === "restaurantImageInput") {
          postData.itemId = $('#restId').val().trim();
          postData.imageType = "Restaurant";
      } else{
          postData.itemId = itemId
          postData.imageType = "RatingID";
      }

      $.post('/logItemImage', postData, function(res) {
          if (uploadImgeInputId === "restaurantImageInput") {
              $('#restaurantPlaceholder').attr("src", imageUrl);
          } else {
              let itemfirst = $(containerId).find('.item').first();
              let imageNew = `<div id="carousel-image-0" data-url-index="0"  data-url-link="${imageUrl}" class="item active">
                                  <label for="${uploadImgeInputId}"><img class="carousel-image" src="${imageUrl}"/></label>
                              </div>`
              if (itemfirst.hasClass('default')){
                  itemfirst.remove();
                  $(containerId).find('.item-image-carousel').html(imageNew);
              } else {
                  $(containerId).find('.item').removeClass('active')
                  $(containerId).find('.item-image-carousel').append(imageNew);
              }
              $(containerId).find('.imageDelete').show();
              $('#item-review-'+itemId).find('img').attr('src',imageUrl);
              let info_review = JSON.parse($('#'+itemId).text().trim()||'{}');
              let current_img = {
                url:imageUrl,
                uploadedDate:new Date()
              }
              info_review.imageUrls.push(current_img);
              $('#'+itemId).text(JSON.stringify(info_review));
          }
      })
      .catch(function(error) {
        Swal.fire({
              title: "Unable to Upload Image",
              text: "We had a problem saving this image.",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#3cb371",
          });
      })
  }


  function scrollToNextItemRating(orderId){
    setTimeout(()=>{
      let elem = $(`#rating_${orderId}`);
      let elemAddon = $(`#rating_addon_${orderId}`);
      if(elem.length){
        elem = elem.find('.ratings-form:not(.rated)');
        elemAddon= elemAddon.find('.ratings-form:not(.rated)');
        elem.find('div[id^=collapse-item-]').collapse('show');
        elemAddon.find('div[id^=collapse-addon-]').collapse('show');
//adding top-80 to handle the header's 80 size
        if(elem.length && elemAddon.length) {
//          $('html, body').animate({ scrollTop: elem.offset().top }, 400);
           $('html, body').animate({ scrollTop: elem.offset().top-80 }, 400);
        } else {
          if(elemAddon.length)  $('html, body').animate({ scrollTop: elemAddon.offset().top-80 }, 400);
          if(elem.length)       $('html, body').animate({ scrollTop: elem.offset().top-80 }, 400);
        }
      }
    }, 400); //400 to let the rating reload get completed first
  }

}

/*----For expert-reiew-toggle start -----*/
 $('.toggle-expert-review').click(function (e) {
    var expertText = "Expert Review";
    var basicText = "Basic Review";
    var currentText = $(this).text().trim();
    var targetForm = $(this).attr('data-target');
    // toggle text
    // toggle expert form
    if (currentText === expertText) {
      // open expert form
      $(this).text(basicText);
      $(targetForm).slideDown();
    } else {
      // close expert form
      $(this).text(expertText);
      $(targetForm).slideUp();
    }
    e.preventDefault();
  });
/*----For expert-reiew-togggle end -----*/

function renderRatingDiscounts(orderId){
  console.log("in renderRatingDiscounts for orderid...",orderId);
  let data = {
    orderId : orderId
  };
  return $.promisedAjax({
    url: '/getItemRatingDiscountsByOrder',
    type: 'POST',
    data: JSON.stringify(data),
    contentType: 'application/json',
    dataType: 'json'
  }).then((discounts) => {
    let discountItems = discounts.discountCredits;
    let discountFirstTimeOrder = discounts.discountFirstTimeOrder;

    // Credit on rating items
    discountItems.forEach(d => {
      let $itemContainer = $(`.ratingForm_${d.menuItemId }_${orderId}`);
      let _discount = d.eligibleDiscounts;

      // Discount tag under submit button
      if (_discount && (_discount.customerFirstMenuItemRating || _discount.customerRatingRestaurant)) {
        let discountSubmitPer = parseFloat(_discount.submitCredit || 0);
        let discountSubmitAmt = parseFloat(_discount.submitCreditAmt || 0);

        if (discountSubmitPer > 0){
          let html = `<div class="center-flex-block discount-credit-alert">
                        <div class="alert discount-tag" style="padding:10px;">
                            <strong>Rate & Submit to get ${discountSubmitPer.toFixed(0)}% back in credit - $${discountSubmitAmt.toFixed(2)}.</strong>
                        </div>
                      </div>`
          $itemContainer.find(".discount-bottom").html(html);
        }
      }

      // Discount tag for exprt review
      if (_discount && _discount.customerFirstExpertReview) {
        let html = `<div class="alert discount-tag" style="padding:3px;">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i> <b>Add Expert Review and get extra ${_discount.customerFirstExpertReview}% off - $${numberFormat(_discount.expertReviewCreditAmt)}.</b>
                    </div>`
        $itemContainer.find(".discount-expert-review").html(html);
      }
    })

    // Credit on rating restaurant
    if(discountFirstTimeOrder && discountFirstTimeOrder.submitCreditAmt){
      let discountSubmitPer = parseFloat(discountFirstTimeOrder.submitCredit || 0);
      let discountSubmitAmt = parseFloat(discountFirstTimeOrder.submitCreditAmt || 0);
      let orderType = $(`#temp-checkout-order-type-${orderId}`).val()
      const RATE_ORDER_TYPE_CREDITS = ['pickup', 'delivery']

      let html = `<div class="center-flex-block discount-credit-alert">
                    <div class="alert discount-tag" style="padding:10px;">
                        <strong>Complete ${RATE_ORDER_TYPE_CREDITS.includes(orderType) ? 'a review for this order' : ' an expert review of this restaurant'  } to earn ${discountSubmitPer.toFixed(0)}% on your whole order - $<span id="discountSubmitAmt">${discountSubmitAmt.toFixed(2)}</span> in free food/drinks.</strong>
                    </div>
                  </div>`

      if (RATE_ORDER_TYPE_CREDITS.includes(orderType)) $(`#order-review-${orderId}`).find(".discount-rating-order").html(html)
      else  $(`#collapseVenue-${orderId}`).find(".discount-bottom").html(html);
    }

    // Discount tag for exprt review
    let $totalDiscount = $(`#checkout-total-discount-text-${orderId}`);
    let discountText   = $totalDiscount && discounts && discounts.totalOrderDiscount ? discounts.totalOrderDiscount : 0;

    const totalNotRatedItems = $(`#rating-section-${orderId}`).find(".ratings-form:visible").length;
    if(!discountText || totalNotRatedItems <= 0){
      $(`#checkout-completed-btn-${orderId}`).hide()
      if (totalNotRatedItems <= 0) $(`#rating-section-container-${orderId}`).hide()
    }else{
      $totalDiscount.text(discountText.toFixed(2));
      $(`#checkout-completed-btn-${orderId}`).fadeIn()
    }

    return res;
  })
  .catch((err) => {
    return err;
  })
}

window.reviewPageInit        = reviewPageInit;
window.renderRatingDiscounts = renderRatingDiscounts;


// if not order rating (restaurant page), load the code immediately !!!!!!!!!!!!!!!
// if not order rating (restaurant page), load the code immediately !!!!!!!!!!!!!!!
if (!window.location.href.match(/(\/restaurant\/)/gi)){
  reviewPageInit();
}


});

$(document).on("click",".insta-share-button",function(){
  var imageSrc = $(this).parents(".ratings-form").find(".img-placeholder").attr("src");
  if(imageSrc == "/images/tempfood.png"){
    imageSrc = window.location.origin + imageSrc;
  }
  window.location.href = "plateratewebtonative:instaShare?link=" + imageSrc;
});
$(document).on("click",".btn-pinterest-share-button-mobile",function(){
  var imageSrc = $(this).parents(".ratings-form").find(".img-placeholder").attr("src");
  if(imageSrc == "/images/tempfood.png"){
    imageSrc = window.location.origin + imageSrc;
  }
  window.location.href = "plateratewebtonative:pinterestShare?link=" + imageSrc;
});

$(document).ready(function(){
  if(window.navigator && window.navigator.userAgent){
    var userAgent = window.navigator.userAgent;
    if(userAgent == "PlateRateForIOS" || userAgent == 'PlateRateForAndroid'){
        $(".insta-share-button").show();
        $(".pinterest-share-button-web").addClass('hide');
        $(".pinterest-share-button-mobile").removeClass('hide');
    } else {
        $(".pinterest-share-button-web").removeClass('hide');
        $(".pinterest-share-button-mobile").addClass('hide');
    }
  }
})
